import React, { useEffect, useState, useRef, useCallback, useMemo, useContext } from 'react';
import { TreeView } from 'devextreme-react/tree-view';
import * as events from 'devextreme/events';
import { navigation, navigationAdmin, navigationCompanyAdmin, navigationUnauthenticated, navigationSIFRW, navigationAIUser} from '../../app-navigation';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import { useAuth } from '../../contexts/auth';
import './SideNavigationMenu.scss';


import { ThemeContext } from '../../theme';

export default function SideNavigationMenu(props) {
  const {
    children,
    selectedItemChanged,
    openMenu,
    compactMode,
    onMenuReady
  } = props;

  const { user, refreshSession } = useAuth();
  const [items, setItems] = useState([]);
  const theme = useContext(ThemeContext);
  const { isLarge } = useScreenSize();

  function normalizePath (navList) {
    return navList.map((item) => (
      { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
    ))
  }

  const { navigationData: { currentPath } } = useNavigation();

  const treeViewRef = useRef(null);
  const wrapperRef = useRef();
  const getWrapperRef = useCallback((element) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      events.off(prevElement, 'dxclick');
    }

    wrapperRef.current = element;
    events.on(element, 'dxclick', (e) => {
      openMenu(e);
    });
  }, [openMenu]);

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance();
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);

  useEffect(() => {
    let itl = [];
    if (user&&user.signInUserSession) {
      itl.push(...normalizePath(navigation));
      const cognitoGroups = user.signInUserSession.idToken.payload['cognito:groups'];
      if (cognitoGroups) {
        if (cognitoGroups.includes("admin")) {
          itl.push(...normalizePath(navigationAIUser));
          itl.push(...normalizePath(navigationSIFRW));
          itl.push(...normalizePath(navigationAdmin));

        } else {
          const groupsStr = cognitoGroups.join();
          if (groupsStr.includes("sifrw_")) {
            itl.push(...normalizePath(navigationSIFRW));
          }
          
          const aiUserNav = [];
          if (groupsStr.includes("aiuser") || groupsStr.includes("kbmanager")) {
            const assistantItem = navigationAIUser.find(item => item.path === '/axpc-assistant');
            if (assistantItem) {
              aiUserNav.push(assistantItem);
            }
          }
          if (groupsStr.includes("kbmanager")) {
            const kbItem = navigationAIUser.find(item => item.path === '/ai-knowledge-base');
            if (kbItem) {
              aiUserNav.push(kbItem);
            }
          }
          if (aiUserNav.length > 0) {
            itl.push(...normalizePath(aiUserNav));
          }
        }
      }
    } else {
      itl.push(...normalizePath(navigationUnauthenticated));
    }
    setItems(itl);
  }, [user, user&&user.signInUserSession]);

  return (
    <div
      className={`dx-swatch-additional${theme?.isDark() ? '-dark' : ''} side-navigation-menu`}
      ref={getWrapperRef}
    >
      {children}
      <div className={'menu-container'}>
        <TreeView
          ref={treeViewRef}
          items={items}
          keyExpr={'path'}
          selectionMode={'single'}
          focusStateEnabled={false}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
        />
      </div>
    </div>
  );
}
